import { EnquiryFormSection } from '@/components/sections'

export const EnquiryPage = () => (
  <>
    <EnquiryFormSection />
  </>
)
